export default class Appointment {
  constructor (data) {
    this.createdAt = data.created_at
    this.patientUuid = data.patient_uuid
    this.practiceUuid = data.practice_uuid
    this.source = data.source
    this.status = data.status
    this.type = data.type
    this.updatedAt = data.updated_at
    this.uuid = data.uuid
  }
}
